export function formatINR(value, decimals = 2) {
  const n = Number(value || 0);
  return n.toLocaleString("en-IN", { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
}

export function rupees(value) {
  return "₹" + formatINR(value);
}

export function can(user, resource, action) {
  if (!user) return false;
  const perms = user.permissions || [];
  return perms.includes("*") || perms.includes(`${resource}:${action}`);
}

export function fmtDate(iso) {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" });
  } catch {
    return iso;
  }
}

export const STATUS_COLORS = {
  Available: "bg-[#E8F5E9] text-[#2D6A4F]",
  Reserved: "bg-[#FFF8E1] text-[#B8860B]",
  Sold: "bg-[#F2EBE1] text-[#8A6D2F]",
  Returned: "bg-[#FDEDED] text-[#9D2A2A]",
  "In Transit": "bg-[#E7F0F5] text-[#2C5D75]",
  Damaged: "bg-[#FDEDED] text-[#9D2A2A]",
  active: "bg-[#E8F5E9] text-[#2D6A4F]",
  matured: "bg-[#FFF8E1] text-[#B8860B]",
  redeemed: "bg-[#F2EBE1] text-[#8A6D2F]",
  cancelled: "bg-[#FDEDED] text-[#9D2A2A]",
  completed: "bg-[#E8F5E9] text-[#2D6A4F]",
  pending: "bg-[#FFF8E1] text-[#B8860B]",
  approved: "bg-[#E8F5E9] text-[#2D6A4F]",
  rejected: "bg-[#FDEDED] text-[#9D2A2A]",
};
